import { useTranslation } from "react-i18next";
import { keyframes } from "@emotion/react";
import { Box } from "@mui/material";

const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
  30% { transform: translateY(-4px); opacity: 1; }
`;

const DOTS = [0, 1, 2];

/**
 * «يكتب…» shown in the assistant bubble before the first delta (plan §3.6):
 * three bouncing dots, labelled for screen readers. Without motion
 * (`prefers-reduced-motion`) the dots stay still.
 */
export default function TypingIndicator() {
  const { t } = useTranslation("aiSupport");

  return (
    <Box
      role="img"
      aria-label={t("conversation.typing")}
      sx={{ display: "flex", alignItems: "center", gap: 0.5, height: 20 }}
    >
      {DOTS.map((dot) => (
        <Box
          key={dot}
          component="span"
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            bgcolor: "text.secondary",
            opacity: 0.4,
            animation: `${bounce} 1.2s ease-in-out ${dot * 0.15}s infinite`,
            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          }}
        />
      ))}
    </Box>
  );
}
